import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Button from 'src/Components/shared/Button'

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  to: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    affordability: PropTypes.number.isRequired
  }).isRequired
}

const BuyersLink = ({ children, className, onClick, to }) => (
  <Button
    element={Link}
    to={to}
    className={className}
    onClick={onClick}
    children={children}
  />
)

BuyersLink.propTypes = propTypes

export default BuyersLink
